import React, { Fragment } from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";

const RouteWithLayout = (props) => {
	const { layout: Layout, component: Component, ...rest } = props;

	return (
		<Route
			{...rest}
			render={(matchProps) =>
				props.authenticationRequired ? (
					localStorage.getItem("token") ? (
						<Layout>
							<Component {...matchProps} />
						</Layout>
					) : (
						<Redirect to="/login" />
					)
				) : (
					<Layout>
						<Component {...matchProps} />
					</Layout>
				)
			}
		/>
	);
};

RouteWithLayout.defaultProps = {
	authenticationRequired: false,
	layout: Fragment,
};

RouteWithLayout.propTypes = {
	component: PropTypes.any.isRequired,
	layout: PropTypes.any.isRequired,
	path: PropTypes.string,
	authenticationRequired: PropTypes.bool,
};

export default RouteWithLayout;
